
export const AppRoutes = {
    BASE: '/',
    Login: '/login',
    News: '/news',
    Partnerships: '/partnerships',
    BecomeExpert: '/become-expert',
    BecomeTrainer:'/become-trainer',
    RequestSupport:'/request-support',
    About: '/about',
    WhereWeWork: '/about/where-we-work',
    Projects: '/about/projects',
    Missions: '/about/missions',
    ICARS:'/partnerships/ICARS',
    ISAC:'/partnerships/ISAC',
    ESCMID: '/partnerships/ESCMID',
    Others: '/partnerships/others',
    GetInvolvedPartnerships: '/partnerships/get-involved',
    WhatIsSpiceExpert: '/become-expert/what-is-spice-expert',
    ExpertStories: '/become-expert/meet-our-experts',
    ExpertApply: '/become-expert/apply',
    ExpertApplyEdit: '/become-expert/edit',
    WhatIsAMSTrainer: '/become-trainer/what-is-ams-trainer',
    OurTrainers: '/become-trainer/our-trainers',
    TrainerApply: '/become-trainer/apply',
    TypesOfSupport: '/request-support/types-of-support',
    HowCanSpiceHelpMyFacility: 'request-support/how-can-spice-help-my-facility',
    RequestSupportApply: '/request-support/apply',
    AboutSpice: '/about/about-spice',
    Governance: '/about/governance',
    Secretariat: '/about/secretariat',
    ContactUs: '/about/contact-us',
    Story: '/story',
    SpiceTeam: 'about/spice-team',
    SelectExpert: '/spice-experts',
    RequestSupportEdit: 'request-support/edit'
};